import { render, staticRenderFns } from "./ToBOrderList.vue?vue&type=template&id=62ca6142&"
import script from "./ToBOrderList.vue?vue&type=script&lang=js&"
export * from "./ToBOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports